import { styled } from '@mui/material/styles';
import { Image, List } from 'core/common/ui/ui-kit';

export const InfoListStyled = styled(List)`
  display: flex;
  flex-wrap: wrap;
`;
export const InfoItemStyled = styled('li')`
  display: flex;
  align-items: center;
  padding: 12px;
`;
export const IconStyled = styled(Image)`
  margin-right: 8px;
`;
export const InfoContentStyled = styled('div')`
  display: flex;
  flex-direction: column;
`;
